if (!customElements.get('aogeo-case-library')) {
  class AogeoCaseLibrary extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      const buttons = Array.from(this.querySelectorAll('[data-case-filter]'));
      const cards = Array.from(this.querySelectorAll('[data-case-category]'));
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const filter = button.dataset.caseFilter || 'all';
          buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          cards.forEach((card) => {
            const groups = (card.dataset.caseCategory || '').split(' ');
            card.hidden = filter !== 'all' && !groups.includes(filter);
          });
        });
      });
    }
  }
  customElements.define('aogeo-case-library', AogeoCaseLibrary);
}
